/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useRef, useEffect, useState } from "react";
import {
  Space,
  Input,
  Tooltip,
  message,
  Table,
  Button,
  Row,
  Dropdown,
  Menu,
  Steps,
} from "antd";

import { capitaliseWithHyphen, capitalize, serialNum } from "../../utils";

import { ReactComponent as Edit_icon } from "../../assests/images/edit-logo.svg";
import { ReactComponent as View_icon } from "../../assests/images/eyeIcon.svg";
import { ReactComponent as Print_icon } from "../../assests/images/printIcon.svg";
import active_account from "../../assests/images/action.png";
import { ReactComponent as UploadIcon } from "../../assests/images/uploadIcon.svg";
import {
  SearchOutlined,
  ReloadOutlined,
  UploadOutlined,
  MailOutlined,
  EllipsisOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import search_icon from "../../assests/images/search-icon.svg";
import Smcs_Loader from "../../assests/images/loader-new.gif";
// import Heading from "../../";
import useCustomNavigate from "../../components/customNavigationHook";
// import "./style.scss";
import Heading from "../../components/Heading";
import EllipsisWithTooltip from "../../components/EllipsisWithToolTip";

import { customerOnboardingAPI } from "../../api/LeadApi";
import "../viewBookingTable/viewBookingTabs/AllBookingTable.scss";
import Highlighter from "react-highlight-words";

import urls from "../../api/urls";
const { CREATE_LEAD } = urls;
// import "./style.scss";
import ActivateAccountModal from "../LeadGenerationCP/ActiveAccount";

const LeadGeneartionList = ({ userType, url }) => {
  const debounceTimeout = useRef(null);
  const [inputSearchValue, setInputSearchValue] = useState("");
  let [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const [showAccoountModal, setShowAccoountModal] = useState(false);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null);
  const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;

  let user =
    {
      CLIENT: "clientLeadId",
      COMPANY: "customerIdCompany",
    }[userType] || "customerId";

  const statusList = [
    {
      value: "DRAFT",
      text: "Draft",
    },
    {
      value: "approved",
      text: "Approved",
    },
    {
      value: "pending",
      text: "HO Approval Pending",
    },
    {
      value: "rejected",
      text: "Rejected",
    },
  ];

  const navigate = useCustomNavigate();
  useEffect(() => {
    getLeadList({
      pageNum: 0,
      pageSize: 10,
      customerType: userType,
    });
  }, []);

  const getLeadList = async (params) => {
    setLoading(true);

    const response = await customerOnboardingAPI.getAllLeadList(params);
    if (response?.status) {
      const res = response?.response?.data;
      setTotalPageSize(res?.count);
      setLoading(false);
      setTableData(
        res?.data?.map(
          (item) =>
            ({
              ...item,
              contactNumbers:
                item?.contactNumbers?.find((e) => e?.type === "default")
                  ?.number ||
                item?.contactNumbers?.[0]?.number ||
                "N/A",
              emails:
                item?.emails?.find((e) => e?.type === "personal")?.email ||
                item?.emails?.[0]?.email ||
                "N/A",
            } || [])
        )
      );
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  function handleIdClick(val) {
    localStorage.setItem(user, val);
    navigate(url);
  }

  const reRoute = (pathName, rateCardName) => {
    navigate(pathName, {
      state: {
        view: true,

        rateCardName,
        userType,
      },
    });
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getLeadList({
          pageNum: 0,
          pageSize: 10,
          customerType: userType,
          ...debouncedFilters,
        });
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedFilters]);

  const handleTableChange = (pagination, filters) => {
    if (filters?.status) {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
        status: filters?.status[0],
      });
    } else {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };
    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          allowClear
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            // console.log(dataIndex, "dataIndex");

            handleSearch(e.target.value, dataIndex);
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => {
      //console.log(dataIndex, "dataIndex");

      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
            fontSize: "14px",
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const columns = [
    {
      title: "SI",
      width: 60,
      dataIndex: "sl",
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: capitaliseWithHyphen(`${userType} Name`),
      dataIndex: "orgName",
      key: "orgName",
      width: 150,
      render: (text, b) => formatText(text, 25),
      ...getColumnSearchProps(
        "orgName",
        `${capitaliseWithHyphen(userType)} Name`
      ),
    },

    {
      title: "Phone Number",
      dataIndex: "contactNumbers",
      key: "contactNumbers",
      width: 100,
      render: (text) => text || "N/A",
      ...getColumnSearchProps("contactNumber", "Phone Number"),
      //render: (text) => text?.[0]?.number || "N/A",
    },
    {
      title: "Email",
      dataIndex: "emails",
      key: "emails",
      width: 100,
      align: "left",
      render: (text) => text || "N/A",
      ...getColumnSearchProps("email", "Email"),
      //render: (text, b) => formatText(text?.[0]?.email, 20),
    },
    {
      title: "Quote List",
      dataIndex: "quotations",
      key: "quotations",
      width: 180,
      render: (text, record) => {
        const pendingStatus = text.find(
          (e) => e.status.toLowerCase() === "pending"
        );
        const rejectedStatus = text.find(
          (e) => e.status.toLowerCase() === "rejected"
        );
        const statusToShow =
          pendingStatus?.status || rejectedStatus?.status || text[0]?.status;

        return text?.length > 0 ? (
          <div className="align-center">
            <a
              onClick={() => {
                // localStorage.setItem("customerId", record?.customerId);
                //navigate(`/cp-quotation-list/${record?.customerId}`);
                userType === "COMPANY"
                  ? navigate(`/cp-quotation-list/${record?.customerId}`, {
                      state: { tab: "3", navigateUrl: "/profile" },
                    })
                  : navigate(`/cp-quotation-list/${record?.customerId}`);
              }}
              style={{ fontSize: 12 }}
            >
              View History
            </a>
            <div
              className={`lead-list-status ml-1 ${
                "CPlead_" + statusToShow?.toLowerCase()
              }`}
              style={{ padding: "2px 5px", width: "45%" }}
            >
              {capitalize(statusToShow)}
            </div>
          </div>
        ) : (
          <span style={{ color: "gray" }}>No Quote</span>
        );
      },
    },

    {
      title: "Reject Reason",
      dataIndex: "remark",
      key: "remark",

      width: 170,
      //render: (text) => (text ? <EllipsisWithTooltip text={text} /> : "N/A"),
      render: (text, b) => formatText(capitaliseWithHyphen(text), 30),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 80,
      render: (text) => text?.split(" ")?.[0] || "N/A",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: statusList,
      width: 100,
      filterMultiple: false,

      render: (text, record) => {
        let approvalStatus = "process";
        let currentStep = 1;
        if (userType === "CP") {
          const approval = record?.approval;
          const getStepStatus = () => {
            if (approval.some((item) => item.status === "REJECTED")) {
              return "error";
            }
            if (approval.every((item) => item.status === "APPROVED")) {
              return "success";
            }
            return "process";
          };
          approvalStatus = getStepStatus();
          const getCurrentStep = (record) => {
            const index = record.findIndex(
              (item) => item.status !== "APPROVED"
            );
            return index === -1 ? record.length : index;
          };
          currentStep = getCurrentStep(approval);
        }
        return userType === "CP" ? (
          <div
            className={`lead-list-status ${"CPlead_" + text?.toLowerCase()}`}
          >
            {text?.toLowerCase() === "pending"
              ? "HO Approval Pending"
              : capitalize(text) || "--"}{" "}
            <Dropdown
              overlay={
                <Steps
                  style={{ backgroundColor: "#FCF1CC", padding: 10 }}
                  direction="vertical"
                  status={approvalStatus}
                  current={currentStep}
                  items={record?.approval?.map((item) => ({
                    title: `${item.approvalStage} (${capitalize(item.status)})`,
                  }))}
                />
              }
            >
              <span className="pointer">
                <EyeOutlined />
              </span>
            </Dropdown>
          </div>
        ) : (
          <div
            className={`lead-list-status ${"CPlead_" + text?.toLowerCase()}`}
          >
            {text?.toLowerCase() === "pending"
              ? "HO Approval Pending"
              : capitalize(text) || "--"}
          </div>
        );
      },
    },

    {
      title: "Actions",
      key: "action",

      className: "actions-col",
      width: 100,
      render: (_, record) => {
        console.log(record?.isActivated, "record");

        return (
          <Space size="small">
            {(userType === "CLIENT" ||
              (userType === "CP" && !record?.isActivated)) && (
              <Tooltip title="Edit" placement="bottom">
                <p
                  className="pointer"
                  style={{ marginBottom: 0 }}
                  onClick={() => handleIdClick(record?.customerId)}
                >
                  <Edit_icon
                    width={23}
                    height={23}
                    disable={record?.status?.toLowerCase() !== "approved"}
                  />
                </p>
              </Tooltip>
            )}
            <Tooltip title="View" placement="bottom">
              <p
                className="pointer"
                style={{ marginBottom: 0 }}
                onClick={() =>
                  // reRoute(
                  //   `/lead-details/APPROVED/${record?.customerId}`,
                  //   record?.quotations
                  // )

                  // navigate(`/customer-details/${record?.customerId}`, {
                  //   state: { heading: "Lead Details" },
                  // })

                  navigate(`/customer-details/${record?.customerId}`, {
                    state: {
                      reRoute:
                        userType === "CP"
                          ? "/cp-lead-generation-list"
                          : "/client-lead-generation-list",
                      heading: "Lead Details",
                      //cpId: record?.customerData?.cpId,
                      //basicEdit: true,
                      apiUrl: CREATE_LEAD,
                      companyDetailview: userType === "CP" ? true : false,
                    },
                  })
                }
              >
                <View_icon
                  width={23}
                  height={23}
                  disable={record?.status?.toLowerCase() !== "approved"}
                />
              </p>
            </Tooltip>
            {userType === "CP" && !record?.isActivated && (
              <>
                <Tooltip title={"Upload branding"} placement="left">
                  <p
                    style={{
                      cursor: "pointer",
                      marginTop: "5px",
                      border: "1px solid rgb(211, 220, 234)",
                      borderRadius: "4px",
                      padding: "0px 4px",
                    }}
                    onClick={() => {
                      handleIdClick(record?.customerId);
                      navigate("/cp-lead-generation", {
                        state: { step: 5 },
                      });
                    }}
                  >
                    <UploadOutlined
                      style={{ fontSize: "12px", color: "#a4a4a6" }}
                    />
                  </p>
                </Tooltip>
                {record?.approval?.every(
                  (item) => item.status?.toLowerCase() === "approved"
                ) &&
                  record?.documents?.some(
                    (item) => item?.type === "BRANDING"
                  ) && (
                    <Tooltip title={"Activate Account"} placement="left">
                      <p
                        style={{
                          cursor: "pointer",
                          marginTop: "5px",
                          border: "1px solid rgb(211, 220, 234)",
                          borderRadius: "4px",
                          padding: "0px 4px",
                        }}
                        onClick={() => {
                          setShowAccoountModal(true);
                          setSelectedCustomerDetails(record);
                        }}
                      >
                        <img
                          src={active_account}
                          alt="Activate Account"
                          style={{ width: "15px", height: "15px" }}
                        />
                      </p>
                    </Tooltip>
                  )}
              </>
            )}

            {userType === "CLIENT" && (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="print">
                      <Tooltip title="Print quotation" placement="left">
                        <div style={{ cursor: "no-drop" }}>
                          <Print_icon width={23} height={23} />
                        </div>
                      </Tooltip>
                    </Menu.Item>
                    <Menu.Item
                      key="sendMail"
                      onClick={() =>
                        navigate("/client-lead-generation", {
                          state: { step: 5 },
                        })
                      }
                    >
                      <Tooltip title="Send mail" placement="left">
                        <div
                          style={{
                            cursor: "no-drop",
                            marginTop: "5px",
                            border: "1px solid rgb(211, 220, 234)",
                            borderRadius: "4px",
                            padding: "0 4px",
                          }}
                        >
                          <MailOutlined
                            style={{
                              fontSize: "12px",
                              color: "#a4a4a6",
                            }}
                          />
                        </div>
                      </Tooltip>
                    </Menu.Item>
                    {record?.status?.toLowerCase() === "approved" &&
                      company?.isRegularNGST === false && (
                        <Menu.Item
                          key="uploadAgreement"
                          onClick={() =>
                            navigate("/client-lead-generation", {
                              state: { step: 5 },
                            })
                          }
                        >
                          <Tooltip title="Upload agreement" placement="left">
                            <div>
                              <UploadOutlined
                                style={{
                                  fontSize: "12px",
                                  color: "#a4a4a6",
                                  marginRight: 6,
                                }}
                              />
                              Upload Agreement
                            </div>
                          </Tooltip>
                        </Menu.Item>
                      )}
                  </Menu>
                }
                trigger={["click"]}
                placement="bottomRight"
              >
                <EllipsisOutlined style={{ fontSize: 20, cursor: "pointer" }} />
              </Dropdown>
            )}
          </Space>
        );
      },
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  // const onSearch = (e) => {
  //   const currValue = e.target.value;
  //   setInputSearchValue(currValue);

  //   const filteredData =
  //     inputSearchValue.length > 0 || inputSearchValue.length == 0
  //       ? filterArray(tableData, currValue)
  //       : filterArray(tableData, currValue);
  //   setdataSource(filteredData);
  // };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setPageNum(0);
    setPageSize(pageSize);
    setInputSearchValue(currValue);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      //getClientApprovalList(0, 20, currValue);
      getLeadList(
        `?pageNum=${pageNum}&pageSize=${pageSize}&search=${currValue}`
      );
    }, 500);
  };

  const handlePageChange = (pagination, filters) => {
    if (filters?.status) {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
        status: filters?.status[0],
      });
    } else {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  return (
    <>
      {userType !== "COMPANY" && (
        <div className="lead-gen-list-container mt-1 ml-2">
          <Heading
            title={capitaliseWithHyphen(`${userType} Lead Generation`)}
            navigateTo={"/onboarding-settings"}
          />
        </div>
      )}
      <div className="master-main-container ml-1 mr-1 table-container">
        <div className="align-center flex-end">
          {/* <div className="pl-1-5 fw-600"></div> */}
          {/* <div className="p-1">
            <Input
              placeholder="Search by keyword"
              bordered
              onChange={onSearch}
              style={{ borderRadius: "5px", height: "40px", width: "400px" }}
              suffix={<img src={search_icon} />}
            />
          </div> */}
          <Row className="p-05">
            <Button
              className="cancel-btn mr-1"
              style={{ minWidth: "5%" }}
              icon={<ReloadOutlined style={{ fontSize: "15px" }} />}
              onClick={() => {
                getLeadList({
                  pageNum: 0,
                  pageSize: 10,
                  customerType: userType,
                });
              }}
            >
              {" "}
              Reload
            </Button>
            <Button
              className="save-btn"
              onClick={() => {
                localStorage.removeItem(user);
                navigate(url);
              }}
            >
              {" "}
              + Add New {capitaliseWithHyphen(userType)}
            </Button>
          </Row>
        </div>
        <Table
          className="view-table table-head-sticky"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          columns={columns}
          defaultCurrent={1}
          onChange={handleTableChange}
          //onChange={handlePageChange}
          dataSource={tableData}
          pagination={{
            // pageSize: pageSize,
            // total: inputSearchValue.length == 0 ? tableData.length : 10,
            current: currentPage,
            pageSize: pageSize,
            total: totalPageSize,
            itemRender: itemRender,
          }}
        />
      </div>
      <ActivateAccountModal
        showAccoountModal={showAccoountModal}
        setShowAccoountModal={setShowAccoountModal}
        selectedCustomerDetails={selectedCustomerDetails}
        fetchLeadList={() =>
          getLeadList({
            pageNum: 0,
            pageSize: 10,
            customerType: userType,
          })
        }
      />
    </>
  );
};

export default LeadGeneartionList;
